import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { logError } from 'utils/logger';
import { EMPTY_LEAVES_BY_STATUS } from '../constants';
import { getAdminLeaves, getEmployeesList } from '../service';

export function useAdminLeaves() {
  const [leavesByStatus, setLeavesByStatus] = useState(EMPTY_LEAVES_BY_STATUS);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchEmployees = useCallback(async () => {
    try {
      const data = await getEmployeesList();
      setEmployees(data);
    } catch (err) {
      toast.error(
        logError({
          message: 'Failed to fetch employees',
          error: err,
          code: 'EMPLOYEES_FETCH_FAILED',
        }),
      );
    } finally {
      setLoading(false);
    }
  }, [setEmployees, setLoading]);

  const fetchLeaves = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getAdminLeaves();
      setLeavesByStatus(data);
    } catch (err) {
      toast.error(
        logError({
          message: 'Failed to fetch admin leaves',
          error: err,
          code: 'ADMIN_LEAVES_FETCH_FAILED',
        }),
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchLeaves();
  }, [fetchLeaves]);

  useEffect(() => {
    fetchEmployees();
  }, [fetchEmployees]);

  return { leavesByStatus, employees, loading, refresh: fetchLeaves };
}
